import React from "react";
import { Navigate } from "react-router-dom";

import { FUEL_PRICE_WORKBENCH_TABS, FUEL_PRICE_WORKBENCH_TAB_QUERY_KEY } from "./constants";

const MarketReferencePricePage = () => {
    return (
        <Navigate
            replace
            to={`/contract-management/fuel-prices?${FUEL_PRICE_WORKBENCH_TAB_QUERY_KEY}=${FUEL_PRICE_WORKBENCH_TABS.MARKET_REFERENCE}`}
        />
    );
};

export default MarketReferencePricePage;
